import { Action, createReducer, on } from '@ngrx/store';
import * as DatasetsStoreActions from './datasets-store.actions';
import { Dataset } from '../models/dataset';

export const datasetsStoreFeatureKey = 'datasetsStore';

export interface State {
    filterSortColumn: any;
    filterSortDirection: 'asc' | 'desc';
    datasets: Dataset[];
    filterValue?: string;
    filterSampleTypes: number[];
}

export const initialState: State = {
    datasets: [],
    filterSampleTypes: [],
    filterSortColumn: 'displayText',
    filterSortDirection: 'asc',
};

export const reducer = createReducer(
    initialState,

    on(DatasetsStoreActions.loadDatasetsStores, (state, action) => {
        return { ...state, datasets: action.data };
    }),

    on(DatasetsStoreActions.setFilter, (state, action) => {
        return {
            ...state,
            filterValue: action.filterValue,
            filterSampleTypes: action.sampleTypes,
        };
    }),

    on(DatasetsStoreActions.setSampleTypesFilter, (state, action) => {
        return {
            ...state,
            filterSampleTypes: action.sampleTypes,
        };
    }),

    on(DatasetsStoreActions.setSampleTypesSort, (state, action) => {
        return {
            ...state,
            filterSortColumn: action.filterSortColumn,
            filterSortDirection: action.filterSortDirection,
        };
    })
);
